import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  white-space: nowrap;\n\n  > p {\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  color: ",
        ";\n  text-align: right;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 18px;\n  vertical-align: text-bottom;\n  margin-left: 2px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  font-size: 14px;\n  display: flex;\n  //width: 100%;\n  position: relative;\n  align-items: center;\n  flex-direction: column;\n  line-height: 22px;\n  border-radius: 4px;\n  border: 1px solid ",
        ";\n  padding: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  letter-spacing: -0.14px;\n\n  div {\n    color: ",
        ";\n  }\n\n  > p {\n    margin: 0;\n  }\n\n  i {\n    margin-left: 4px;\n    margin-bottom: 2px;\n  }\n\n  ",
        "\n  .chip-desc {\n    color: ",
        ";\n  }\n\n  .tooltip-desc {\n    color: ",
        ";\n    max-width: 410px;\n  }\n\n  :hover {\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  > b {\n    text-align: left;\n    font-size: 16px;\n    font-weight: 600;\n    color: ",
        ";\n  }\n\n  div {\n    display: flex;\n    font-size: 14px;\n    color: ",
        ";\n    width: 380px;\n    word-wrap: break-word;\n  }\n\n  a {\n    color: ",
        ";\n    display: flex;\n    font-size: 14px;\n    align-items: center;\n    font-weight: 600;\n  }\n\n  .title {\n    font-size: 20px;\n    font-weight: 700;\n  }\n\n  .description {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 1.5;\n    letter-spacing: -0.16px;\n    margin-bottom: 8px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from "react";
import styled, { useTheme } from "styled-components";
import { ArrowRight, Cart, DownLoadDiasbled, EditStudio, Print, Sizes, Studio } from "@/components/icon/IconList";
import Icon from "@/components/icon/Icon";
import Link from "next/link";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { TooltipWithIcon } from "@/components/Product/Handout/TooltipWithIcon";
export var AllowanceListType;
(function(AllowanceListType) {
    AllowanceListType["print"] = "print";
    AllowanceListType["viewer"] = "viewer";
    AllowanceListType["editStudio"] = "editStudio";
    AllowanceListType["writeStudio"] = "writeStudio";
    AllowanceListType["selling"] = "slot";
    AllowanceListType["warningPrint"] = "warningPrint";
})(AllowanceListType || (AllowanceListType = {}));
export const HandoutAllowanceListTypeWithString = {
    ["print"]: "프린터 출력 (PC,100부)",
    ["viewer"]: "파일 다운로드 불가",
    ["editStudio"]: "자료 편집하기",
    ["writeStudio"]: "문제 편집 가능",
    ["slot"]: "자료 저작 및 판매 가능",
    ["warningPrint"]: "프린트 출력 불가"
};
export const handoutAllowanceChipList = [
    {
        key: "viewer",
        color: "info",
        hasInfo: true,
        link: "https://solvookguide.oopy.io/guide/5",
        description: "쏠북의 모든 수업자료는 저작권 보호를 위해 쏠북의 뷰어 기능을 통해서만 열람할 수 있습니다. 프린트 출력은 뷰어의 출력하기 버튼을 통해 가능합니다. (PC에서만 가능)"
    },
    {
        key: "print",
        color: "info",
        hasInfo: false
    },
    {
        key: "editStudio",
        color: "info",
        hasInfo: true,
        link: "https://solvookguide.oopy.io/guide/studio/edit",
        linkTitle: "편집하기 기능 알아보기",
        description: "문제의 순서를 바꾸거나 삭제할 수 있어요. "
    },
    {
        key: "writeStudio",
        color: "info",
        hasInfo: true,
        link: "https://solvookguide.oopy.io/guide/6",
        linkTitle: "편집하기 기능 알아보기",
        description: "문제의 순서를 바꾸거나 삭제할 수 있어요. 또한 텍스트 수정도 가능해요."
    }
];
export const HandoutAllowanceChip = (param)=>{
    let { chipItem , handleDrawer , productType  } = param;
    const theme = useTheme();
    const { isTablet  } = useWindowDimensions();
    const { key: allowanceKey , color , link , hasInfo , description , linkTitle  } = chipItem;
    const title = HandoutAllowanceListTypeWithString[allowanceKey];
    return /*#__PURE__*/ _jsx(AllowanceChipWrapper, {
        type: color,
        style: {
            pointerEvents: hasInfo ? "auto" : "none"
        },
        onMouseEnter: ()=>{
            if (isTablet) return;
            mixpanelEvent("Product Detail Page Marker hovered", {
                "Product Type": productType,
                "Marker Name": title,
                "Marker Btn Link": link
            });
        },
        onClick: ()=>{
            if (isTablet) {
                handleDrawer(chipItem);
                mixpanelEvent("Product Detail Page Marker hovered", {
                    "Product Type": productType,
                    "Marker Name": title,
                    "Marker Btn Link": link
                });
            }
        },
        children: /*#__PURE__*/ _jsx(TooltipWithIcon, {
            color: theme.new.colors.sol_gray_600,
            icon: null,
            message: /*#__PURE__*/ _jsx(TooltipItem, {
                title: title,
                link: link,
                description: description,
                productType: productType,
                linkTitle: linkTitle
            }),
            link: link,
            size: Sizes.small,
            children: /*#__PURE__*/ _jsx(TooltipContent, {
                allowanceKey: allowanceKey,
                title: title
            })
        })
    });
};
const TooltipContent = (param)=>{
    let { allowanceKey , title  } = param;
    const renderIcon = useCallback(()=>{
        switch(allowanceKey){
            case "print":
                return /*#__PURE__*/ _jsx(Icon, {
                    icon: Print,
                    size: Sizes.medium
                });
            case "viewer":
                return /*#__PURE__*/ _jsx(Icon, {
                    icon: DownLoadDiasbled,
                    size: Sizes.medium
                });
            case "editStudio":
                return /*#__PURE__*/ _jsx(Icon, {
                    icon: EditStudio,
                    size: Sizes.medium
                });
            case "writeStudio":
                return /*#__PURE__*/ _jsx(Icon, {
                    icon: Studio,
                    size: Sizes.medium
                });
            case "slot":
                return /*#__PURE__*/ _jsx(Icon, {
                    icon: Cart,
                    size: Sizes.medium
                });
            case "warningPrint":
                return /*#__PURE__*/ _jsx(Icon, {
                    icon: Print,
                    size: Sizes.medium
                });
            default:
                return null;
        }
    }, []);
    return /*#__PURE__*/ _jsxs(TooltipContentLayout, {
        children: [
            /*#__PURE__*/ _jsx(ChipLayoutContainer, {
                children: renderIcon()
            }),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    title,
                    allowanceKey === "editStudio" && /*#__PURE__*/ _jsx(Em, {
                        children: "Beta"
                    })
                ]
            })
        ]
    });
};
const TooltipContentLayout = styled.div.withConfig({
    componentId: "sc-c18001bd-0"
})(_templateObject());
export const TooltipItem = (param)=>{
    let { title , link , description , productType , linkTitle  } = param;
    const theme = useTheme();
    return /*#__PURE__*/ _jsxs(TooltipWrapper, {
        children: [
            /*#__PURE__*/ _jsx("b", {
                className: "title",
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "description",
                children: description
            }),
            link && /*#__PURE__*/ _jsxs(Link, {
                href: link,
                target: "_blank",
                onClick: ()=>mixpanelEvent("Product Detail Page Marker Detail Clicked", {
                        "Product Type": productType,
                        "Marker Name": title,
                        "Marker Btn Link": link
                    }),
                children: [
                    linkTitle || "자세히 보기",
                    /*#__PURE__*/ _jsx(Icon, {
                        icon: ArrowRight,
                        size: Sizes.xsmall,
                        color: theme.new.colors.indigo500
                    })
                ]
            })
        ]
    });
};
const Em = styled.em.withConfig({
    componentId: "sc-c18001bd-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_mint_300);
const ChipLayoutContainer = styled.div.withConfig({
    componentId: "sc-c18001bd-2"
})(_templateObject2());
const AllowanceChipWrapper = styled.div.withConfig({
    componentId: "sc-c18001bd-3"
})(_templateObject3(), (props)=>props.theme.new.colors.sol_gray_100, (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.type === "warning" && "\n		div {\n			color: ".concat(props.theme.new.colors.sol_red_400, ";\n		}\n	\n	border: 1px solid ").concat(props.theme.new.colors.sol_red_100, ";\n	"), (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.sol_gray_0);
const TooltipWrapper = styled.div.withConfig({
    componentId: "sc-c18001bd-4"
})(_templateObject4(), (props)=>props.theme.new.colors.sol_gray_800, (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.indigo500);
